namespace $.$$ {
	$mol_style_define( $shm_hitalama_map_widget_float_table_column, {
		flex: { direction: 'column', basis: '30rem', grow: 0, shrink: 0 },
		maxWidth: '42vw',
		minWidth: '20rem',
		minHeight: 0,
		background: { color: $mol_theme.back },
		border: { left: { width: '1px', style: 'solid', color: $mol_theme.line } },
		Head: {
			minWidth: 0,
			maxWidth: '100%',
			padding: $mol_gap.block,
			align: { items: 'center' },
		},
		Title: { flex: { grow: 1, shrink: 1 }, minWidth: 0 },
		Code: { minHeight: '8rem', textAlign: 'left' },
		Code_label: { Label: { align: { items: 'center' } } },
		Code_scroll: { maxHeight: $mol_style_func.calc( '15lh + 1rem' ), minHeight: '8rem', padding: 0 },
		'[shm_hitalama_map_widget_float_table_column_expanded]': {
			true: {
				flex: { grow: 1, shrink: 1, basis: 'auto' },
				width: '100%',
				maxWidth: '100%',
				minWidth: 0,
				Code_scroll: { maxHeight: 'none', minHeight: 0 },
			},
		},
		Help: { color: $mol_theme.shade },
		Body: {
			flex: { grow: 1, shrink: 1 },
			minHeight: 0,
			padding: $mol_gap.block,
		},
	} )
}
